import React, { useState, useEffect } from "react";
// import { CreateClinicalNoteRequest } from "../types/clinicalNote.types";
import { format } from "date-fns"; // Add this import
import { ClinicalNoteType, ClinicalNoteDTO, CreateClinicalNoteRequest } from "../types/clinicalNote.types"; // ✅ All together


import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Card,
  CardContent,
  Tabs,
  Tab,
  Chip,
  Grid,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useLocation } from "react-router-dom";
import { useClinicalNotes } from "../hooks/useClinicalNotes";
import { useResidents } from "../hooks/useResidents";
// import { ClinicalNoteType } from "../types/clinicalNote.types";
import carePlanService from "../services/carePlanService";
import { CarePlanDTO } from "../types/careplan.types";

const clinicalNoteSchema = yup.object({
  residentId: yup.string().uuid().required("Resident is required"),
  noteType: yup
    .string()
    .oneOf(["PROGRESS", "NURSE", "SOCIAL_WORK", "SPIRITUAL_CARE", "PHYSICIAN"])
    .required("Note type is required"),
  content: yup
    .string()
    .required("Note content is required")
    .min(10, "Note must be at least 10 characters"),
  noteDate: yup.date().required("Date and time are required").nullable(),
});

// type ClinicalNoteDTO = {
//   id: string;
//   residentId: string;
//   residentName?: string;
//   authorName?: string;
//   noteType: string;
//   subject: string;
//   content: string;
//   noteDate: string;
//   isSigned: boolean;
// };

type FormData = yup.InferType<typeof clinicalNoteSchema>;

const ClinicalNotesPage: React.FC = () => {
  const [notes, setNotes] = useState<any[]>([]);
  const [topTab, setTopTab] = useState(0); // 0=EMR,1=Clinical Notes,2=Care Plan
  const [emrTab, setEmrTab] = useState(0); // 0=Medication,1=Nurse Notes
  const [activeTab, setActiveTab] = useState(0);
  const [selectedResident, setSelectedResident] = useState<string | null>(null);
  const [prefilledResident, setPrefilledResident] = useState<any | null>(null);
  const location = useLocation();

  useEffect(() => {
    // When coming from the Residents page "Medication" action, open the EMR
    // section and show the Medication sub-tab by default.
    if (location.state?.defaultTab === "medication") {
      setTopTab(0); // EMR section
      setEmrTab(0); // Medication sub-tab
    }
  }, [location.state]);

  const [editingNoteId, setEditingNoteId] = useState<string | null>(null);
  const [editFormData, setEditFormData] = useState({
    noteType: "",
    content: "",
    noteDate: null as Date | null,
  });

 const handleEditNote = (note: any) => {
  console.log("🔥 EDIT CLICKED! Note ID:", note.id); // ← ADD THIS
  setEditingNoteId(note.id);
  setValue("residentId", note.residentId);
  setValue("noteType", note.noteType);
  setValue("content", note.content);
  setValue("noteDate", note.noteDate);
  console.log(" editingNoteId SET:", note.id); // ← ADD THIS
};
  const handleCancelEdit = () => {
    setEditingNoteId(null);
    setEditFormData({ noteType: "", content: "", noteDate: null });
    reset();
  };

  const handleDeleteNote = async (noteId: string) => {
    if (!window.confirm("Are you sure you want to delete this note?")) return;

    try {
      await deleteClinicalNote(noteId); // From useClinicalNotes hook
      setNotes((prev) => prev.filter((note) => note.id !== noteId));
    } catch (error) {
      console.error("Failed to delete note:", error);
    }
  };

  // MAR header
  const [marHeader, setMarHeader] = useState({
    physician: "",
    medicalRecordNo: "",
    admissionDate: "",
    dob: "",
    allergies: [] as string[],
  });

  // meds
  const [medications, setMedications] = useState<
    Array<{
      med: string;
      dose: string;
      route: string;
      start: string;
      schedule: string;
    }>
  >([
    {
      med: "Atorvastatin 40mg Tablet",
      dose: "40mg",
      route: "PO",
      start: "6/26/25",
      schedule: "Daily (ACH 0)",
    },
    {
      med: "Embecta Autosheld 30g/5mm NDL",
      dose: "As ordered",
      route: "SC",
      start: "6/26/25",
      schedule: "As needed",
    },
    {
      med: "Fluticasone 50mcg Nasal Spray",
      dose: "1 spray each nostril",
      route: "INH",
      start: "9/19/25",
      schedule: "Once daily",
    },
  ]);

  const [medForm, setMedForm] = useState({
    med: "",
    dose: "",
    route: "",
    start: "",
    schedule: "",
  });

  // NEW: track row being edited; null = add mode
  const [editingIndex, setEditingIndex] = useState<number | null>(null);

  // nurse notes
  const [nurseEntries, setNurseEntries] = useState<
    Array<{
      id: number;
      noteDate: Date | null;
      medication: string;
      dosage: string;
      reason: string;
      results: string;
      initials: string;
    }>
  >([]);
  const [nurseForm, setNurseForm] = useState<{
    noteDate: Date | null;
    medication: string;
    dosage: string;
    reason: string;
    results: string;
    initials: string;
  }>({
    noteDate: null,
    medication: "",
    dosage: "",
    reason: "",
    results: "",
    initials: "",
  });

  const [carePlanTab, setCarePlanTab] = useState(0);

  // Care Plan state
  const [carePlan, setCarePlan] = useState<CarePlanDTO | null>(null);
  const [carePlanLoading, setCarePlanLoading] = useState(false);
  const [carePlanError, setCarePlanError] = useState<string | null>(null);
  const [carePlanFields, setCarePlanFields] = useState({
    diagnosticsPlan: "",
    dailyActivities: "",
    ambulation: "",
    woundCare: "",
  });

  // Care Plan state


  const [filterType, setFilterType] = useState<string>("All");
  const [viewingNote, setViewingNote] = useState<string | null>(null);

  // Use real API hooks
  const {
    clinicalNotes,
    loading,
    error,
    createClinicalNote,
    fetchClinicalNotes,
    fetchClinicalNotesByType,
    signClinicalNote,
    updateClinicalNote,
    deleteClinicalNote,
  } = useClinicalNotes();

  const {
    residents,
    loading: residentsLoading,
    fetchResidents,
  } = useResidents();
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm<FormData>({
    resolver: yupResolver(clinicalNoteSchema),
  });

  const filteredNotes =
    activeTab === 0
      ? notes
      : notes.filter(
          (note) =>
            (activeTab === 1 && note.noteType === "PROGRESS") ||
            (activeTab === 2 && note.noteType === "NURSE") ||
            (activeTab === 3 && note.noteType === "SOCIAL_WORK") ||
            (activeTab === 4 && note.noteType === "SPIRITUAL_CARE")
        );
const onSubmit = async (data: FormData) => {
  try {
    console.log(" onSubmit called! editingNoteId:", editingNoteId); // ← ADD THIS
  console.log("Form data:", data);
    const payload: CreateClinicalNoteRequest = {
      residentId: data.residentId,
      noteType: data.noteType as ClinicalNoteType,
      subject: "Quick Note", // Better than "subject"
      content: data.content,
      noteDate: data.noteDate
        ? format(data.noteDate as Date, "yyyy-MM-dd'T'HH:mm:ss.SSS")
        : format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS"),
      isConfidential: false,
    };

    //Imported ClinicalNoteDTO has id?: string - perfect!
    let savedNote: ClinicalNoteDTO;

    if (editingNoteId) {
       console.log("🔄 UPDATE MODE - calling updateClinicalNote");
      savedNote = await updateClinicalNote(editingNoteId, payload);
    } else {
          console.log("➕ CREATE MODE - calling createClinicalNote"); // ← ADD THIS

      savedNote = await createClinicalNote(payload);
    }

    if (!savedNote?.id) {
      throw new Error("Failed to save note");
    }

    const resident = residents.find((r) => r.id === savedNote.residentId!);
    setNotes((prev) => {
      const filtered = prev.filter(n => n.id !== savedNote.id!);
      return [{
        id: savedNote.id!,
        residentId: savedNote.residentId,
        residentName: resident?.firstName ?? savedNote.residentName ?? "Unknown",
        noteType: savedNote.noteType,
        author: savedNote.authorName ?? "Unknown",
        noteDate: new Date(savedNote.noteDate!),
        content: savedNote.content,
        status: savedNote.isSigned ? "Signed" : "Draft",
      }, ...filtered];
    });

    setEditingNoteId(null);
    reset();
  } catch (e) {
    console.error("Error saving clinical note:", e);
  }
};


  const labelMap: Record<string, string> = {
    PROGRESS: "Progress",
    NURSE: "Nurse",
    SOCIAL_WORK: "Social Work",
    SPIRITUAL_CARE: "Spiritual Care",
    PHYSICIAN: "Physician",
  };

  // Sync selectedResident with form's residentId field
  useEffect(() => {
    if (selectedResident) {
      setValue("residentId", selectedResident); // Connects state to form!
    } else {
      setValue("residentId", ""); // Clear if no resident selected
    }
  }, [selectedResident, setValue]);

  // Mock residents for dropdown / patient details
  // const residents = [
  //   {
  //     id: 1, name: 'John Smith', dob: '1954-03-15', sex: 'Male', allergies: ['Penicillin'], attendingPhysician: 'Dr. Johnson', room: '201', bp: '120/80', weight: '58Kg', height: '5ft 6in', bmi: '22', EMRNo: 'A12345'
  //   },
  //   { id: 2, name: 'Mary Johnson', dob: '1948-07-22', sex: 'Female', allergies: ['Latex', 'Peanuts'], attendingPhysician: 'Dr. Williams', room: '202', bp: '120/80', weight: '58Kg', height: '5ft 6in', bmi: '22', EMRNo: 'A12345' },
  //   { id: 3, name: 'Robert Williams', dob: '1965-11-08', sex: 'Male', allergies: [], attendingPhysician: 'Dr. Brown', room: '203', bp: '120/80', weight: '58Kg', height: '5ft 6in', bmi: '22', EMRNo: 'A12345' },
  //   { id: 4, name: 'Jennifer Brown', dob: '1972-05-30', sex: 'Female', allergies: ['Sulfa'], attendingPhysician: 'Dr. Davis', room: '204', bp: '120/80', weight: '58Kg', height: '5ft 6in', bmi: '22', EMRNo: 'A12345' },
  // ];

  // If navigated from Residents page with residentId in state, pre-select resident
  React.useEffect(() => {
    const state: any = location.state;
    if (state && state.residentId) {
      const id = state.residentId;
      setSelectedResident(id);
      setValue("residentId", id);
      // if navigation asked to open medication view, switch tabs
      if (state.view === "medication") {
        setTopTab(0);
        setEmrTab(0);
      }
      if (state.view === "nurse-notes") {
        setTopTab(0);
        setEmrTab(1);
      }
    }
    if (state && state.patientDetails) {
      setPrefilledResident(state.patientDetails);
    }
  }, [location.state, setValue]);

  // Fetch care plan when resident is selected
  useEffect(() => {
    const fetchCarePlan = async () => {
      if (!selectedResident) {
        setCarePlan(null);
        setCarePlanFields({
          diagnosticsPlan: "",
          dailyActivities: "",
          ambulation: "",
          woundCare: "",
        });
        return;
      }

      setCarePlanLoading(true);
      setCarePlanError(null);

      try {
        const plan = await carePlanService.getCarePlanByResidentId(
          String(selectedResident)
        );

        if (plan) {
          setCarePlan(plan);
          setCarePlanFields({
            diagnosticsPlan: plan.diagnosticsPlan || "",
            dailyActivities: plan.dailyActivities || "",
            ambulation: plan.ambulation || "",
            woundCare: plan.woundCare || "",
          });
        } else {
          setCarePlan(null);
          setCarePlanFields({
            diagnosticsPlan: "",
            dailyActivities: "",
            ambulation: "",
            woundCare: "",
          });
        }
      } catch (error: any) {
        console.error("Error loading care plan:", error);
        setCarePlanError("Failed to load care plan");
      } finally {
        setCarePlanLoading(false);
      }
    };

    fetchCarePlan();
  }, [selectedResident]);

  // Fetch care plan when resident is selected
  useEffect(() => {
    const fetchCarePlan = async () => {
      if (!selectedResident) {
        setCarePlan(null);
        setCarePlanFields({
          diagnosticsPlan: "",
          dailyActivities: "",
          ambulation: "",
          woundCare: "",
        });
        return;
      }

      setCarePlanLoading(true);
      setCarePlanError(null);

      try {
        const plan = await carePlanService.getCarePlanByResidentId(
          String(selectedResident)
        );

        if (plan) {
          setCarePlan(plan);
          setCarePlanFields({
            diagnosticsPlan: plan.diagnosticsPlan || "",
            dailyActivities: plan.dailyActivities || "",
            ambulation: plan.ambulation || "",
            woundCare: plan.woundCare || "",
          });
        } else {
          setCarePlan(null);
          setCarePlanFields({
            diagnosticsPlan: "",
            dailyActivities: "",
            ambulation: "",
            woundCare: "",
          });
        }
      } catch (error: any) {
        console.error("Error loading care plan:", error);
        setCarePlanError("Failed to load care plan");
      } finally {
        setCarePlanLoading(false);
      }
    };

    fetchCarePlan();
  }, [selectedResident]);

    const getResident = (id: string | null) =>
    residents.find((r) => r.id === id) || null;

  const calcAge = (dob: string) => {
    try {
      const birth = new Date(dob);
      const diff = Date.now() - birth.getTime();
      const ageDt = new Date(diff);
      return Math.abs(ageDt.getUTCFullYear() - 1970);
    } catch {
      return "";
    }
  };

  const residentBanner =
    prefilledResident ||
    (selectedResident ? getResident(selectedResident) : null);

  // Handlers for MAR header and medication entries
  const handleAddAllergy = (value: string) => {
    if (!value) return;
    setMarHeader((prev) => ({
      ...prev,
      allergies: Array.from(new Set([...prev.allergies, value])),
    }));
  };

  const handleRemoveAllergy = (value: string) => {
    setMarHeader((prev) => ({
      ...prev,
      allergies: prev.allergies.filter((a) => a !== value),
    }));
  };

  // ADD / UPDATE MED
  const handleAddMedication = () => {
    if (!medForm.med) return;

    if (editingIndex === null) {
      // add mode
      setMedications((prev) => [...prev, { ...medForm }]);
    } else {
      // edit mode – update existing row
      setMedications((prev) => {
        const copy = [...prev];
        copy[editingIndex] = { ...medForm };
        return copy;
      });
      setEditingIndex(null);
    }

    setMedForm({ med: "", dose: "", route: "", start: "", schedule: "" });
  };

  // NEW: load row into form when Edit is clicked
  const handleEditMedication = (index: number) => {
    const row = medications[index];
    setMedForm({ ...row });
    setEditingIndex(index);
    setTopTab(0);
    setEmrTab(0);
  };

  const handleCancelEditMedication = () => {
    setEditingIndex(null);
    setMedForm({ med: "", dose: "", route: "", start: "", schedule: "" });
  };

  const handleRemoveMedication = (index: number) => {
    setMedications((prev) => prev.filter((_, i) => i !== index));
    if (editingIndex === index) {
      handleCancelEditMedication();
    }
  };

  // nurse
  const handleAddNurseEntry = () => {
    if (!nurseForm.noteDate || !nurseForm.medication) return;
    setNurseEntries((prev) => [{ id: Date.now(), ...nurseForm }, ...prev]);
    setNurseForm({
      noteDate: null,
      medication: "",
      dosage: "",
      reason: "",
      results: "",
      initials: "",
    });
  };

  const handleRemoveNurseEntry = (id: number) => {
    setNurseEntries((prev) => prev.filter((e) => e.id !== id));
  };

  // Save care plan handler
  const handleSaveCarePlan = async () => {
    if (!selectedResident) {
      alert("Please select a resident first");
      return;
    }

    setCarePlanLoading(true);
    setCarePlanError(null);

    try {
      if (carePlan) {
        // Update existing care plan
        const updated = await carePlanService.updateCarePlan(carePlan.id, {
          diagnosticsPlan: carePlanFields.diagnosticsPlan,
          dailyActivities: carePlanFields.dailyActivities,
          ambulation: carePlanFields.ambulation,
          woundCare: carePlanFields.woundCare,
        });
        setCarePlan(updated);
        alert("Care plan updated successfully");
      } else {
        // Create new care plan
        const created = await carePlanService.createCarePlan({
          residentId: String(selectedResident),
          diagnosticsPlan: carePlanFields.diagnosticsPlan,
          dailyActivities: carePlanFields.dailyActivities,
          ambulation: carePlanFields.ambulation,
          woundCare: carePlanFields.woundCare,
        });
        setCarePlan(created);
        alert("Care plan created successfully");
      }
    } catch (error: any) {
      console.error("Error saving care plan:", error);
      setCarePlanError("Failed to save care plan");
      alert(
        "Error saving care plan: " +
        (error.response?.data?.message || error.message)
      );
    } finally {
      setCarePlanLoading(false);
    }
  };

  return (
    <Box sx={{ width: "100%", maxWidth: "100%", px: 2 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Patient Details
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, mb: 2 }}>
            {residentBanner ? (
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6}>
                  <Typography variant="h6">
                    Name: {residentBanner.name} &nbsp;&nbsp; &nbsp; EMR Number:
                    {residentBanner.EMRNo}
                  </Typography>
                  <Typography variant="body2">
                    <span style={{ fontWeight: "bold" }}>BP:</span>{" "}
                    {residentBanner.bp} &nbsp;&nbsp;
                    <span style={{ fontWeight: "bold" }}>Height:</span>{" "}
                    {residentBanner.height} &nbsp;&nbsp;
                    <span style={{ fontWeight: "bold" }}>Weight:</span>{" "}
                    {residentBanner.weight} &nbsp;&nbsp;
                    <span style={{ fontWeight: "bold" }}>BMI:</span>{" "}
                    {residentBanner.bmi}
                  </Typography>

                  <Typography variant="body2">
                    <span style={{ fontWeight: "bold" }}>Room:</span>{" "}
                    {residentBanner.room} &nbsp;&nbsp;
                    <span style={{ fontWeight: "bold" }}>Age:</span>{" "}
                    {residentBanner.dob ? calcAge(residentBanner.dob) : "N/A"}{" "}
                    &nbsp;&nbsp;
                    <span style={{ fontWeight: "bold" }}>Sex:</span>{" "}
                    {residentBanner.sex}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2">
                    Attending Physician:{" "}
                    <strong>{residentBanner.attendingPhysician}</strong>
                  </Typography>
                  <Chip label="  Allergies" size="small" />
                  <Box sx={{ mt: 1 }}>
                    {residentBanner.allergies &&
                    residentBanner.allergies.length > 0 ? (
                      residentBanner.allergies.map((a: string) => (
                        <Chip
                          key={a}
                          label={a}
                          color="error"
                          size="small"
                          sx={{ mr: 1 }}
                        />
                      ))
                    ) : (
                      <Chip label="No Known Allergies" size="small" />
                    )}
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Typography variant="body2">
                Select a resident from Residents list to prefill patient
                details.
              </Typography>
            )}
          </Paper>

          <Paper sx={{ p: 2, mb: 3 }}>
            <Tabs value={topTab} onChange={(e, v) => setTopTab(v)}>
              <Tab label="EMR" />
              <Tab label="Clinical Notes" />
              <Tab label="Care Plan" />
            </Tabs>
          </Paper>

          {topTab === 0 && (
            <Paper sx={{ p: 2 }}>
              <Tabs
                value={emrTab}
                onChange={(e, v) => setEmrTab(v)}
                sx={{ mb: 2 }}
              >
                <Tab label="Medication" />
                <Tab label="Nurse Notes" />
              </Tabs>

              {emrTab === 0 && (
                <Box sx={{ minHeight: 300, border: "1px solid #e0e0e0", p: 2 }}>
                  <Typography variant="h6">Medications</Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 2 }}
                  >
                    List of current medications would appear here.
                  </Typography>

                  {/* Medication form */}
                  <Paper sx={{ p: 2, mb: 2 }}>
                    <Typography variant="subtitle1" gutterBottom>
                      {editingIndex === null
                        ? "Add Medication Order"
                        : "Edit Medication Order"}
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} md={5}>
                        <TextField
                          label="Medication"
                          fullWidth
                          value={medForm.med}
                          onChange={(e) =>
                            setMedForm((p) => ({ ...p, med: e.target.value }))
                          }
                        />
                      </Grid>
                      <Grid item xs={6} md={2}>
                        <TextField
                          label="Dose"
                          fullWidth
                          value={medForm.dose}
                          onChange={(e) =>
                            setMedForm((p) => ({ ...p, dose: e.target.value }))
                          }
                        />
                      </Grid>
                      <Grid item xs={6} md={1}>
                        <TextField
                          label="Route"
                          fullWidth
                          value={medForm.route}
                          onChange={(e) =>
                            setMedForm((p) => ({ ...p, route: e.target.value }))
                          }
                        />
                      </Grid>
                      <Grid item xs={6} md={2}>
                        <TextField
                          label="Start"
                          fullWidth
                          value={medForm.start}
                          onChange={(e) =>
                            setMedForm((p) => ({ ...p, start: e.target.value }))
                          }
                        />
                      </Grid>
                      <Grid item xs={6} md={2}>
                        <FormControl fullWidth>
                          <InputLabel>Schedule</InputLabel>
                          <Select
                            label="Schedule"
                            value={medForm.schedule}
                            onChange={(e) =>
                              setMedForm((p) => ({
                                ...p,
                                schedule: e.target.value as string,
                              }))
                            }
                          >
                            <MenuItem value="Once daily">Once daily</MenuItem>
                            <MenuItem value="Twice daily">Twice daily</MenuItem>
                            <MenuItem value="Three times daily">
                              Three times daily
                            </MenuItem>
                            <MenuItem value="Four times daily">
                              Four times daily
                            </MenuItem>
                            <MenuItem value="Every 4 hours">
                              Every 4 hours
                            </MenuItem>
                            <MenuItem value="Every 6 hours">
                              Every 6 hours
                            </MenuItem>
                            <MenuItem value="Every 8 hours">
                              Every 8 hours
                            </MenuItem>
                            <MenuItem value="As needed (PRN)">
                              As needed (PRN)
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <Button
                          variant="contained"
                          onClick={handleAddMedication}
                          sx={{ mr: 1 }}
                        >
                          {editingIndex === null
                            ? "+ Add Medication"
                            : "Update Medication"}
                        </Button>
                        {editingIndex !== null && (
                          <Button
                            variant="outlined"
                            color="inherit"
                            onClick={handleCancelEditMedication}
                          >
                            Cancel
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                  </Paper>

                  {/* Medication table */}
                  <Paper sx={{ p: 2, mb: 2 }}>
                    <Typography variant="subtitle1" gutterBottom>
                      Current Medication Orders
                    </Typography>
                    <TableContainer>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Medication</TableCell>
                            <TableCell>Dose</TableCell>
                            <TableCell>Route</TableCell>
                            <TableCell>Start</TableCell>
                            <TableCell>Schedule</TableCell>
                            <TableCell align="right">Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {medications.map((row, idx) => (
                            <TableRow key={`${row.med}-${idx}`}>
                              <TableCell>{row.med}</TableCell>
                              <TableCell>{row.dose}</TableCell>
                              <TableCell>{row.route}</TableCell>
                              <TableCell>{row.start}</TableCell>
                              <TableCell>{row.schedule}</TableCell>
                              <TableCell align="right">
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: 1,
                                  }}
                                >
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() => handleEditMedication(idx)}
                                  >
                                    Edit
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    color="error"
                                    onClick={() => handleRemoveMedication(idx)}
                                  >
                                    Remove
                                  </Button>
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </Box>
              )}

              {emrTab === 1 && (
                <Box sx={{ minHeight: 300, border: "1px solid #e0e0e0", p: 2 }}>
                  <Typography variant="h6">
                    Nurse's Medication / Treatment Notes
                  </Typography>

                  <Paper sx={{ p: 2, mb: 2 }}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} md={6}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DateTimePicker
                            label="Date / Hour"
                            value={nurseForm.noteDate}
                            onChange={(v) =>
                              setNurseForm((p) => ({ ...p, noteDate: v }))
                            }
                            slotProps={{ textField: { fullWidth: true } }}
                          />
                        </LocalizationProvider>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Initials"
                          fullWidth
                          value={nurseForm.initials}
                          onChange={(e) =>
                            setNurseForm((p) => ({
                              ...p,
                              initials: e.target.value,
                            }))
                          }
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Medication / Treatment"
                          fullWidth
                          value={nurseForm.medication}
                          onChange={(e) =>
                            setNurseForm((p) => ({
                              ...p,
                              medication: e.target.value,
                            }))
                          }
                        />
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <TextField
                          label="Dosage"
                          fullWidth
                          value={nurseForm.dosage}
                          onChange={(e) =>
                            setNurseForm((p) => ({
                              ...p,
                              dosage: e.target.value,
                            }))
                          }
                        />
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <TextField
                          label="Reason"
                          fullWidth
                          value={nurseForm.reason}
                          onChange={(e) =>
                            setNurseForm((p) => ({
                              ...p,
                              reason: e.target.value,
                            }))
                          }
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          label="Results / Response"
                          fullWidth
                          value={nurseForm.results}
                          onChange={(e) =>
                            setNurseForm((p) => ({
                              ...p,
                              results: e.target.value,
                            }))
                          }
                          multiline
                          rows={3}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          onClick={handleAddNurseEntry}
                        >
                          Add Nurse Entry
                        </Button>
                      </Grid>
                    </Grid>
                  </Paper>

                  <Paper sx={{ p: 2 }}>
                    <Typography variant="subtitle1" gutterBottom>
                      Entries
                    </Typography>
                    <TableContainer>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Date / Hour</TableCell>
                            <TableCell>Medication / Treatment</TableCell>
                            <TableCell>Dosage</TableCell>
                            <TableCell>Reason</TableCell>
                            <TableCell>Results / Response</TableCell>
                            <TableCell>Initials</TableCell>
                            <TableCell align="right">Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {nurseEntries.length > 0 ? (
                            nurseEntries.map((e) => (
                              <TableRow key={e.id}>
                                <TableCell>
                                  {e.noteDate
                                    ? e.noteDate.toLocaleString()
                                    : ""}
                                </TableCell>
                                <TableCell>{e.medication}</TableCell>
                                <TableCell>{e.dosage}</TableCell>
                                <TableCell>{e.reason}</TableCell>
                                <TableCell>{e.results}</TableCell>
                                <TableCell>{e.initials}</TableCell>
                                <TableCell align="right">
                                  <Button
                                    size="small"
                                    color="error"
                                    onClick={() => handleRemoveNurseEntry(e.id)}
                                  >
                                    Remove
                                  </Button>
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={7} align="center">
                                No nurse entries
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </Box>
              )}
            </Paper>
          )}

          {topTab === 1 && (
            <Paper sx={{ p: 2 }}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {editingNoteId
                      ? "Edit Clinical Note"
                      : "Add New Clinical Note"}
                  </Typography>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Box sx={{ mb: 2 }}>
                      <Controller
                        name="noteType"
                        control={control}
                        render={({ field }) => (
                          <FormControl fullWidth error={!!errors.noteType}>
                            <InputLabel>Note Type</InputLabel>
                            <Select {...field}>
                              <MenuItem value="PROGRESS">
                                Progress Note
                              </MenuItem>
                              <MenuItem value="NURSE">Nurse Note</MenuItem>
                              {/* <MenuItem value="Therapy">Therapy Note</MenuItem> */}
                              <MenuItem value="SOCIAL_WORK">
                                Social Work Note
                              </MenuItem>
                              <MenuItem value="PHYSICIAN">Physician</MenuItem>
                            </Select>
                            {errors.noteType && (
                              <Typography color="error" variant="caption">
                                {errors.noteType.message}
                              </Typography>
                            )}
                          </FormControl>
                        )}
                      />
                    </Box>

                    <Box sx={{ mb: 2 }}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Controller
                          name="noteDate"
                          control={control}
                          render={({ field }) => (
                            <DateTimePicker
                              label="Date & Time"
                              value={field.value}
                              onChange={field.onChange}
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  error: !!errors.noteDate,
                                },
                              }}
                            />
                          )}
                        />
                      </LocalizationProvider>
                      {errors.noteDate && (
                        <Typography color="error" variant="caption">
                          {errors.noteDate.message}
                        </Typography>
                      )}
                    </Box>

                    <Box sx={{ mb: 2 }}>
                      <Controller
                        name="content"
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            fullWidth
                            label="Note Content"
                            multiline
                            rows={6}
                            error={!!errors.content}
                            helperText={errors.content?.message}
                          />
                        )}
                      />
                    </Box>

                    <Box display="flex" justifyContent="flex-end" mt={2}>
                      <Button
                        type="submit"
                        variant="contained"
                        sx={{ py: 1.3, px: 4 }}
                      >
                        Save Clinical Note
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>

           <Typography variant="h6" gutterBottom>
  Clinical Notes List
</Typography>
<TableContainer>
  <Table>
    <TableHead>
      <TableRow>
        <TableCell>Resident</TableCell>
        <TableCell>Note Type</TableCell>
        <TableCell>Author</TableCell>
        <TableCell>Date/Time</TableCell>
        <TableCell>Status</TableCell>
        <TableCell align="right">Actions</TableCell> {/* ✅ New column */}
      </TableRow>
    </TableHead>
    <TableBody>
      {Array.isArray(filteredNotes) && filteredNotes.length > 0 ? (
        filteredNotes.map((note) => (
          <TableRow key={note.id}>
            <TableCell>
              <Typography variant="body2">
                {note.residentName}
              </Typography>
            </TableCell>
            <TableCell>
              <Chip
                label={labelMap[note.noteType]}
                size="small"
                color="primary"
              />
            </TableCell>
            <TableCell>{note.author}</TableCell>
            <TableCell>
              {note.noteDate.toLocaleString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })}
            </TableCell>
            <TableCell>
              <Chip
                label={note.status}
                size="small"
                color={note.status === "Signed" ? "success" : "warning"}
              />
            </TableCell>
            <TableCell align="right">
              <Box sx={{ display: "flex", gap: 0.5 }}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => handleEditNote(note)}
                  // disabled={note.status === "Signed"} // Can't edit signed notes
                >
                  Edit
                </Button>
                <Button
                  size="small"
                  color="error"
                  variant="outlined"
                  onClick={() => handleDeleteNote(note.id)}
                  // disabled={note.status === "Signed"} // Can't delete signed notes
                >
                  Delete
                </Button>
              </Box>
            </TableCell>
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell colSpan={6} align="center">
            No clinical notes found
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  </Table>
</TableContainer>

            </Paper>
          )}

          {topTab === 2 && (
            <Paper sx={{ p: 2 }}>
              {/* Loading and Error States */}
              {carePlanLoading && (
                <Box sx={{ mb: 2, p: 2, bgcolor: "info.lighter" }}>
                  <Typography>Loading care plan...</Typography>
                </Box>
              )}
              {carePlanError && (
                <Box sx={{ mb: 2, p: 2, bgcolor: "error.lighter" }}>
                  <Typography color="error">{carePlanError}</Typography>
                </Box>
              )}

              <Tabs
                value={carePlanTab}
                onChange={(e, v) => setCarePlanTab(v)}
                sx={{ mb: 2 }}
              >
                <Tab label="Dietary Restrictions" />
                <Tab label="Daily Activities" />
                <Tab label="Ambulation" />
                <Tab label="Wound Care/Skin Check" />
              </Tabs>

              <Box>
                {carePlanTab === 0 && (
                  <Box>
                    <Typography variant="h6">Dietary Restrictions</Typography>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                      <Grid item xs={12}>
                        <TextField
                          label="Dietary Restrictions"
                          fullWidth
                          multiline
                          rows={8}
                          placeholder="Enter dietary restrictions, allergies, nutritional needs, texture modifications, supplements, etc."
                          value={carePlanFields.diagnosticsPlan}
                          onChange={(e) =>
                            setCarePlanFields((prev) => ({
                              ...prev,
                              diagnosticsPlan: e.target.value,
                            }))
                          }
                          disabled={carePlanLoading}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                )}

                {carePlanTab === 1 && (
                  <Box>
                    <Typography variant="h6">Daily Activities</Typography>
                    <TextField
                      fullWidth
                      multiline
                      rows={8}
                      placeholder="Mobility, transfers, ADLs, therapy schedule, observations"
                      sx={{ mt: 1 }}
                      value={carePlanFields.dailyActivities}
                      onChange={(e) =>
                        setCarePlanFields((prev) => ({
                          ...prev,
                          dailyActivities: e.target.value,
                        }))
                      }
                      disabled={carePlanLoading}
                    />
                  </Box>
                )}

                {carePlanTab === 2 && (
                  <Box>
                    <Typography variant="h6">Ambulation</Typography>
                    <TextField
                      fullWidth
                      multiline
                      rows={8}
                      placeholder="Ambulation abilities, assistive devices, fall risk, mobility restrictions"
                      sx={{ mt: 1 }}
                      value={carePlanFields.ambulation}
                      onChange={(e) =>
                        setCarePlanFields((prev) => ({
                          ...prev,
                          ambulation: e.target.value,
                        }))
                      }
                      disabled={carePlanLoading}
                    />
                  </Box>
                )}

                {carePlanTab === 3 && (
                  <Box>
                    <Typography variant="h6">
                      Wound Care / Skin Check
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      rows={8}
                      placeholder="Wound locations, dressing changes, frequency, observations"
                      sx={{ mt: 1 }}
                      value={carePlanFields.woundCare}
                      onChange={(e) =>
                        setCarePlanFields((prev) => ({
                          ...prev,
                          woundCare: e.target.value,
                        }))
                      }
                      disabled={carePlanLoading}
                    />
                  </Box>
                )}
              </Box>
              <Button
                onClick={handleSaveCarePlan}
                disabled={carePlanLoading || !selectedResident}
                variant="contained"
                fullWidth
                sx={{ py: 1.5, mt: 2 }}
              >
                {carePlanLoading
                  ? "Saving..."
                  : carePlan
                    ? "Update Care Plan"
                    : "Create Care Plan"}
              </Button>
            </Paper>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default ClinicalNotesPage;
